// The backend's metadata.reason when another schedule in the organization already has the name
// being saved.
export const EMPLOYMENT_SCHEDULE_NAME_TAKEN = 'employmentScheduleNameTaken';

export const employmentScheduleNameTakenMessage =
  'Det finns redan ett anställningsschema med det namnet.';
